module.exports = __webpack_public_path__ + "img/clients-04.57fc97e6.svg";